<template>
    <div>
        <h1><span style="text-transform: uppercase">{{ this.$store.getters.tests.find(e => e.testid == this.$route.params.id).target }}</span> Test {{ transl["STR_FROM"]}} {{ this.$store.getters.tests.find(e => e.testid == this.$route.params.id).time | unixtimestamp }}
        <span v-if="this.$store.getters.tests.find(e => e.testid == this.$route.params.id).cycler">-  {{ transl["STR_TESTING_DEVICE"]}} {{ GetNickname(this.$store.getters.tests.find(e => e.testid == this.$route.params.id).cycler) }}</span></h1>
<div class="restable">
    <div class="restatable">

        <div style="margin-bottom: 15px" v-if="this.$store.getters.ScreeningPortalEnabled && this.$store.getters.probes.filter(e => e.screeningPortalQueued == true).length == 0">
            <div style="display: flex">
                <div style="width: 290px;" class="magic-button" v-on:click="transmitScreening(true)" v-if="!transfer">
                    <b>Verz&ouml;gert</b> ans Screening Portal &uuml;bermitteln
                </div>
            </div>
        </div>

        
        <table border="0">
            <thead>
                <th width="150">{{ transl["STR_BARCODE"] }}</th>
                <th width="100">{{ transl["STR_POSITION"] }}</th>
                <th width="100">{{ transl["STR_CTValue"] }}</th>
                <th width="100">{{ transl["STR_Valid"] }}</th>
                <th width="150">{{ transl["STR_RESULT"] }}</th>
                <th width="110" v-if="transfer">&Uuml;bertragung</th>
                <th v-if="curves">ROX</th>
                <th v-if="curves">CY5</th>
                <th v-if="curves">CY5 CT</th>
            </thead>
            <tbody>
                <tr v-for="t in this.$store.getters.probes">
                    <td>{{ t.barcode }}</td>
                    <td>{{ t.well }}</td>
                    <td style="min-width: 80px;"><span v-if="t.positive">{{ t.ct }}</span><span v-else>-</span></td>
                    <td :class="{ 'invalid' : !t.valid }">{{ t.valid ? transl["STR_RES_VALID"] : transl["STR_RES_INVALID"] }}</td>
                    <td :class="{ 'positive' : t.positive && t.valid }">{{ t.positive ? transl["STR_RES_POSITIVE"] : transl["STR_RES_NEGATIVE"] }}</td>
                    <td v-if="transfer" align="center">
                        <i v-if="t.transfered" class="fas fa-check-circle"></i>
                        <i v-if="t.transfered == false" class="fas fa-spinner"></i>
                    </td>
                    <td v-if="curves" style="min-width:80px">
                        {{ t.rawROX | round }}
                    </td>
                    <td v-if="curves" style="min-width:80px">
                        {{ t.rawCY5 | round}}
                    </td>
                    <td v-if="curves" style="min-width:80px">
                        {{ t.cy5ct | round}}
                    </td>
                    <td width="30" v-if="t.expressOrder" style="padding: 0px; background-color: gold;min-width: 30px;" align="center" title="Epxress Auswertung">
                        <b>
                            <i class="fas fa-star"></i>
                        </b>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

        <div class="resgraph" v-if="curves">
            <apexchart v-if="series.length > 0" width="800px" height="400px" type="line" :options="options" :series="series"></apexchart>
        </div>
    </div>

    </div>
</template>
<script>
export default({
    props: [ 'test', 'curves', 'admin', 'transl' ],
    filters: {
         round(a) {
            return Math.round(a).toFixed(1);
        },
        unixtimestamp(UNIX_timestamp) {
            var a = new Date(UNIX_timestamp * 1000);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            if(sec < 10) sec="0"+sec;

            if(date < 10) date="0"+date;
            if(month < 10) month="0"+month;
            if(hour < 10) hour="0"+hour;
            if(min < 10) min="0"+min;
            

            var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min + ':' + sec ;
            return time;            
        }
    },
    data() {
        return {
            roxfilter: 1,
            transmit: [],
            transfer: false,
            ScreeningPortal: false,
            nicks: [],
            options: {

annotations: {
  yaxis: [
    {
      y: 1000,
      borderColor: '#FF0000',
      label: {
        borderColor: '#FF0000',
        style: {
          color: '#fff',
          background: '#FF0000'
        },
        text: 'Covid19 Positiv (ROX)'
      }
    },
  ]
},
                legend: {
                    show: true,
                },
                stroke: {
                    width: 1,
                    curve: 'smooth',
                },
                chart: {               
                toolbar: {
                    show: false,
                },                    
                    id: 'chart0'
                },
            },            
            series: [],
        }
    },
    mounted() {


        this.roxfilter = this.$store.getters.covidParams.rox;
        this.options.annotations.yaxis[0].y = this.roxfilter;
        this.options.annotations.yaxis[0].label.text = "COVID19 Positive (Filter:"+this.roxfilter+")";

        this.ScreeningPortal = this.$store.getters.ScreeningPortalEnabled;
        this.loadNicks();


        if(this.curves) {
            this.$store.dispatch("LoadTest", this.$route.params.id)
            .then((r) => {
                r.filter(e => e.wellTarget=="ROX").forEach((r) => {
                    var vxp = [];
                    r.wellDataAmp.split(",").forEach((cc) => {
                        vxp.push(parseFloat(cc))
                    })
                    this.series.push({
                        name: r.wellBarcode,
                        data: vxp,
                    })
                })
            });
        }      
    },
    methods: {
        GetNickname(serial) {
            var nn = this.$store.getters.cyclers.find(e => e.serial == serial);
            if(nn && nn.name) { return nn.name; } else { return serial; }
        },        
        loadNicks() {
            this.nicks = [];
            this.$store.getters.cyclers.forEach((c) => {
                var nickname = localStorage.getItem(c.serial);
                if(nickname) {
                    this.nicks.push({
                        serial: c.serial,
                        nick: nickname,
                    })
                }
            })
        },
        nickname(serial) {
            var find = this.nicks.find(e => e.serial == serial);
            if(find) {
                return find.nick;
            } else {
                return serial;
            }
        },           
        transmitScreening(delay) {
            var testId = this.$route.params.id;
            if(confirm("Möchten Sie die Ergebnisse automatisch an das Screening Portal übermitteln? Es werden nur negativ+gültige Ergebnisse übermittelt.")) {
                this.$store.dispatch("sendScreeningPortal", {
                    probes: this.$store.getters.probes.filter(e => e.positive == false && e.valid == true),
                    delay: delay,
                })
            }
        },        
    }
})
</script>

<style>
.restable {
    display: flex;
}
.restatable {
    width: 800px;
}
.resgraph {
    height: 100%;
    width: 800px;
    margin: auto;
}
</style>